var _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 145C118.137 145 145 118.137 145 85C145 51.8629 118.137 25 85 25C51.8629 25 25 51.8629 25 85C25 118.137 51.8629 145 85 145Z",
    fill: "#8BF2CF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 66,
    width: 73,
    height: 47,
    rx: 5,
    fill: "#3C3C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61.5H85.5H120.5V107H50V61.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 65.9999V103.3C49 106.1 51.3 108.3 54 108.3H116.2C119 108.3 121.2 106 121.2 103.3V65.9999M49 65.9999C49 63.2999 51.2 60.9999 54 60.9999H116.2C118.9 60.9999 121.2 63.1999 121.2 65.9999M49 65.9999L85 89.9999L121.2 65.9999",
    stroke: "#4B27E0",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail1);
export default __webpack_public_path__ + "static/media/email1.2ff82736.svg";
export { ForwardRef as ReactComponent };